import React from "react"
import styled from 'styled-components'
import Menu from './Menu'
import { FaAngleDoubleLeft } from "react-icons/fa";
import raggera from '../img/raggera.png';
import Translate from "./Translate";

const Sidenav = styled.aside`
height: 100%;
position: fixed;
top: 4rem;
left: 0;
overflow-x: hidden;
/*transition: width .3s;*/
`

const Mainarea = styled.div`
/*transition: width .3s;*/
`


function Siderbar({ children, show, onToggleSidebar, wSide }) {

	const wRem = "" + (show ? wSide : 0) + "rem";

	const specificheLink = '/specifiche';
	const specifichePage = window.location.pathname.substr(0, specificheLink.length) === specificheLink;

	return (
		<>
			<Sidenav style={{ width: wRem }}>
				<div className=" position-relative" style={{
					backgroundColor: '#fff',
					zIndex: 10,
					marginTop: specifichePage ? '5.8rem' : '3rem',
				}}>
					{show && (<div className="text-right">
						<span className="cursor-pointer" onClick={onToggleSidebar}>
							<FaAngleDoubleLeft />
						</span>
					</div>)}
					<div className="pt-1 pl-3">
						<Menu sezione={specifichePage ? 1 : 0} />
					</div>
					<br />
					<br />
					<br />
					<img src={raggera} alt="" style={{
						width: '24rem',
						marginLeft: '-12rem',
						transform: 'scaleX(-1)',
					}} />
				</div>
				{specifichePage
					? (
						<div className="position-absolute m-3" style={{ bottom: '9rem' }}>
							{/*<FontAwesomeIcon icon={faWindowClose} />*/}
							<span className="pl-2 font-weight-bold cursor-pointer text-uppercase" onClick={() => window.location.href = "/"} >
								<Translate chiave="CLOSE" pacchetto="Site" />
							</span>
						</div>
					)
					: (
						<div className="position-absolute m-3" style={{ bottom: '9rem' }}>
							<div className="d-flex align-items-center">
								<div>
									<a
										className="font-weight-bold pl-2"
										href="/specifiche"
										target="_blank"
										style={{ fontSize: '80%', color: '#000' }}
									><Translate chiave="SPEC" pacchetto="Site" /></a>
								</div>
							</div>
						</div>
					)}

			</Sidenav>
			<Mainarea className="pr-3 pl-5 mainarea" style={{ marginLeft: wRem }}>
				{children}
			</Mainarea>
		</>
	);

}

export default Siderbar;